import React from 'react';

import styled from 'styled-components';

import DownCaretIcon from 'common/Icons/DownCaretIcon';
import Button from 'components/lib/Button';
import Dropdown from 'components/lib/Dropdown';

import { EmailMatchingRecordType } from './types';

type Props = {
  item: EmailMatchingRecordType;
  onEdit: (item: EmailMatchingRecordType) => void;
  onDownloadPdf: (item: EmailMatchingRecordType) => void;
};

const Wrapper = styled.div`
  visibility: hidden;
  display: flex;
  justify-content: flex-end;
`;

const ActionButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const EmailMatchingTableActions = ({ item, onEdit, onDownloadPdf }: Props) => {
  const menuItems = [
    {
      label: <span data-test-id={`email-matching-${item.id}-action-edit`}>Edit</span>,
      key: 'edit',
      onClick: () => onEdit(item),
    },
    ...(item.file_path
      ? [
          {
            label: <span data-test-id={`email-matching-${item.id}-action-download-pdf`}>Download PDF</span>,
            key: 'download-pdf',
            onClick: () => onDownloadPdf(item),
          },
        ]
      : []),
  ];

  return (
    <Wrapper className="hover-visible" onClick={(event) => event.stopPropagation()}>
      <Dropdown
        menu={{
          items: menuItems,
        }}
      >
        <Button data-test-id={`email-matching-${item.id}-actions-button`}>
          <ActionButtonContent>
            <span>Actions</span>
            <DownCaretIcon />
          </ActionButtonContent>
        </Button>
      </Dropdown>
    </Wrapper>
  );
};

export default EmailMatchingTableActions;
